/**
 * 主商品sku
 */
 import * as React from 'react'
 import ProductSku from './sku-layout';
 import { useAppDispatch } from '../../redux/hooks';
 import { setInfoMap } from '../../redux/reduces/skuSlice'
 import getSkuInventory from '../../common/inventory';
 import SkuNone from './sku-none';
 
 export default function ProductGoods ( props: any ) {
     const { skuInfoMap, inventory = {}, type } = props;
     // 无sku
     if (!skuInfoMap) {
       return <SkuNone {...props}/>
     }

     // 库存数据
     const {preferedDispatchId, repoSkuInventory = {}, defaultDispatchId} = inventory;
     const {skuMap} = repoSkuInventory[preferedDispatchId] || repoSkuInventory[defaultDispatchId] || '';
     // 无库存字段，异常兜底
     if (!skuMap) return null;

    const dispatch = useAppDispatch(); 
    dispatch( setInfoMap({
        type,
        info: getSkuInventory(skuInfoMap, skuMap)
    }))
 
     return (
         <div className='layout-sku'>
             <ProductSku {...props} showMore startOrder/>
         </div>
     )
 }
 